// Baixa um Blob como arquivo (link temporário + clique). Usado nas
// exportações que vêm da API (ex.: CSV de pacientes da Clínica).
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
}
